import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export const ContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: `0 0 ${spacing.bigx1} 0`,
  fontSize: '1.5rem',
})

export const ContentStyled = styled.div({
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  fontWeight: font.weight.regular,
  lineHeight: font.size.lg.lineHeight,

  marginBottom: spacing.md,
})

export const TitleStyled = styled(ContentStyled)({
  fontWeight: font.weight.bold,
  color: colors.neutral[900],
  marginBottom: 0,
})
